import { graphql } from '@/generated/gql';

export const SUPPLIER_CONTACT_DETAILS_QUERY = graphql(/* GraphQL */ `
  query SupplierContactDetails($id: uuid!) {
    cmdi {
      contact(where: { id: { _eq: $id } }) {
        id
        supplierId
        title
        firstName
        lastName
        email
        role
        preferredLanguage
      }
    }
  }
`);
